import ctx from "../../plugins/axios";
/**
 * Gets the Product List by Look-Up.
 *
 * @returns {Promise<*>}
 */
const createListThpc = async (obj) => {

return await ctx.post("/specialty_list_thpc/clone", obj);
};

export default createListThpc;
